import { useQuery } from '@tanstack/react-query';

import { _getEntityRoles } from '@/api/entity-roles/queries';

import { isOwnerRole } from './common';
import { useCallerHeldRoles } from './use-caller-held-roles';

/** Whether the caller holds the entity's Owner role — the protected-permission signal. */
export const useCallerIsOwner = (entityId?: string | null): boolean => {
  const heldRoleIds = useCallerHeldRoles(entityId);
  const roles = useQuery(_getEntityRoles(entityId));

  return (roles.data?.roles ?? []).some((role) => isOwnerRole(role) && heldRoleIds.has(role.id));
};
